var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRuble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "300.000000pt",
    height: "300.000000pt",
    viewBox: "0 0 300.000000 300.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,300.000000) scale(0.100000,-0.100000)",
    fill: "#4A0073",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1355 2994 c-229 -33 -374 -77 -544 -164 -411 -213 -697 -599 -788 -1065 -24 -125 -24 -405 0 -530 29 -148 74 -279 142 -413 210 -413 580 -694 1045 -793 139 -30 418 -33 555 -6 148 29 279 74 413 142 413 210 694 580 793 1045 19 87 23 136 23 290 0 154 -4 203 -23 290 -98 460 -377 830 -781 1039 -217 112 -401 159 -650 165 -85 3 -168 2 -185 0z m351 -259 c398 -69 734 -317 914 -676 175 -350 175 -768 0 -1118 -310 -618 -1062 -869 -1679 -561 -618 310 -869 1062 -561 1679 178 355 512 604 905 675 108 19 311 20 421 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1195 2235 c-58 -29 -60 -35 -65 -335 l-5 -275 -85 -5 c-122 -7 -160 -35 -160 -120 0 -85 38 -113 160 -120 l85 -5 3 -62 3 -63 -76 0 c-117 0 -175 -42 -175 -126 0 -36 6 -51 34 -82 34 -37 35 -37 125 -40 l91 -4 0 -80 c0 -93 16 -129 68 -154 50 -24 100 -13 140 31 31 33 32 38 32 119 l0 85 149 3 c171 3 195 13 220 85 13 35 13 46 0 78 -26 71 -50 80 -220 83 l-150 3 3 62 3 62 210 5 c237 6 278 16 366 87 123 99 175 215 167 374 -4 76 -9 97 -41 162 -61 123 -177 213 -306 237 -29 5 -164 10 -300 10 -197 0 -252 -3 -276 -15z m568 -249 c44 -18 94 -77 108 -128 22 -81 -22 -176 -98 -214 -33 -17 -62 -19 -218 -19 l-180 0 -3 188 -2 187 180 0 c129 0 190 -4 213 -14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRuble);
export default __webpack_public_path__ + "static/media/ruble.d160312d21bcaefef78638d85720a0fa.svg";
export { ForwardRef as ReactComponent };